/** Normalize pickup/drop JSON from API into { latitude, longitude }. */
export function normalizeCoords(loc) {
    if (!loc || typeof loc !== 'object') return null;
    const latitude = Number(loc.latitude ?? loc.lat);
    const longitude = Number(loc.longitude ?? loc.lng ?? loc.lon);
    if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;
    if (latitude === 0 && longitude === 0) return null;
    return { latitude, longitude };
}

export function hasValidCoords(loc) {
    return normalizeCoords(loc) !== null;
}
